import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Row, Table, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { FModal, LoadingSpinner } from './../../components'
import Paginator from './../../components/Pagination/V2/Paginator'
import CashMahanService from './../../services/cashMahan/CashMahanService'
import CashMahanStatusBadge from './CashMahanStatusBadge'
import PaymentRequestDetails from './PaymentRequestDetails'
import { CashMahanEmpty, CashMahanError } from './CashMahanStates'
import {
  PAYMENT_STATUSES,
  apiErrorMessage,
  customerLabel,
  displayText,
  extractCollection,
  extractPagination,
  formatDate,
  formatMoney,
  isForbidden,
  isSuccess,
  recordId,
  rtlProps,
  technicianId,
  technicianLabel,
  unwrapData
} from './cashMahanUtils'

export default class PaymentRequests extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: '',
      items: [],
      noResult: false,
      previousPages: [],
      nextPages: [],
      currentPage: 1,
      perPage: 15,
      status: '',
      fixerId: '',
      customer: '',
      paymobTransactionId: '',
      fromDate: null,
      toDate: null,
      from: '',
      to: '',
      detailsModal: false,
      selectedId: '',
      selectedItem: null
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.load()
  }

  queryParams() {
    return {
      page: this.state.currentPage,
      perPage: this.state.perPage,
      status: this.state.status,
      fixerId: this.state.fixerId,
      customer: this.state.customer,
      paymobTransactionId: this.state.paymobTransactionId,
      from: this.state.from,
      to: this.state.to
    }
  }

  load() {
    this.setState({ loading: true, error: '' })
    CashMahanService.getPaymentRequests(this.queryParams(), (res) => {
      if (isForbidden(res)) {
        this.setState({ loading: false })
        this.props.history.push('/403')
        return
      }
      if (!isSuccess(res)) {
        this.setState({ loading: false, error: apiErrorMessage(res), items: [], noResult: false })
        return
      }
      const data = unwrapData(res)
      const items = extractCollection(data, 'paymentRequests')
      const pagination = extractPagination(data)
      this.setState({
        loading: false,
        error: '',
        items,
        noResult: !items.length,
        previousPages: pagination.previousPages,
        nextPages: pagination.nextPages,
        currentPage: pagination.currentPage || this.state.currentPage
      })
    })
  }

  applyFilter() {
    this.setState({ currentPage: 1 }, () => this.load())
  }

  resetFilter() {
    this.setState({
      status: '',
      fixerId: '',
      customer: '',
      paymobTransactionId: '',
      fromDate: null,
      toDate: null,
      from: '',
      to: '',
      currentPage: 1
    }, () => this.load())
  }

  changePage(page) {
    this.setState({ currentPage: page }, () => this.load())
  }

  handleDate(type, date) {
    const iso = date ? new Date(date + ' Z').toISOString().split('T')[0] : ''
    if (type === 'from') {
      this.setState({ fromDate: date, from: iso })
    } else {
      this.setState({ toDate: date, to: iso })
    }
  }

  openDetails(item) {
    this.setState({
      detailsModal: true,
      selectedItem: item,
      selectedId: recordId(item)
    })
  }

  renderFilters() {
    return (
      <div>
        <Row>
          <Col md="2">
            <FormGroup>
              <Label>Status</Label>
              <UncontrolledDropdown>
                <DropdownToggle caret className='actionsBtn' style={{ width: '100%' }}>
                  {this.state.status || 'All'}
                </DropdownToggle>
                <DropdownMenu className='scrolledMenu'>
                  <DropdownItem onClick={() => this.setState({ status: '' })}>All</DropdownItem>
                  {PAYMENT_STATUSES.map((status) => (
                    <DropdownItem key={status} onClick={() => this.setState({ status })}>{status}</DropdownItem>
                  ))}
                </DropdownMenu>
              </UncontrolledDropdown>
            </FormGroup>
          </Col>
          <Col md="2">
            <FormGroup>
              <Label>Fixer ID</Label>
              <Input value={this.state.fixerId} onChange={(e) => this.setState({ fixerId: e.target.value })} placeholder="fixerId" />
            </FormGroup>
          </Col>
          <Col md="2">
            <FormGroup>
              <Label>Customer</Label>
              <Input value={this.state.customer} onChange={(e) => this.setState({ customer: e.target.value })} placeholder="Customer" />
            </FormGroup>
          </Col>
          <Col md="2">
            <FormGroup>
              <Label>Paymob transaction ID</Label>
              <Input value={this.state.paymobTransactionId} onChange={(e) => this.setState({ paymobTransactionId: e.target.value })} placeholder="Paymob ID" />
            </FormGroup>
          </Col>
          <Col md="2">
            <FormGroup>
              <Label>From</Label>
              <div className='date'>
                <DatePicker
                  selected={this.state.fromDate}
                  onChange={(date) => this.handleDate('from', date)}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="From"
                />
              </div>
            </FormGroup>
          </Col>
          <Col md="2">
            <FormGroup>
              <Label>To</Label>
              <div className='date'>
                <DatePicker
                  selected={this.state.toDate}
                  onChange={(date) => this.handleDate('to', date)}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="To"
                />
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md="2">
            <FormGroup>
              <Label>Per page</Label>
              <Input type="select" value={this.state.perPage} onChange={(e) => this.setState({ perPage: e.target.value })}>
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md="10" style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Button className='actionsBtn' style={{ backgroundColor: '#3a4248', borderColor: '#3a4248', color: '#fff' }} onClick={() => this.applyFilter()}>Filter</Button>
            <Button className='actionsBtn' style={{ backgroundColor: '#a91010', borderColor: '#a91010', color: '#fff' }} onClick={() => this.resetFilter()}>Reset</Button>
            <Button className='actionsBtn' onClick={() => this.load()}>Refresh</Button>
          </Col>
        </Row>
      </div>
    )
  }

  renderTable() {
    return (
      <Table hover bordered striped responsive size="md">
        <thead>
          <tr>
            <th style={{ textAlign: 'center' }}>Technician</th>
            <th style={{ textAlign: 'center' }}>Customer</th>
            <th style={{ textAlign: 'center' }}>Reference</th>
            <th style={{ textAlign: 'center' }}>Service amount</th>
            <th style={{ textAlign: 'center' }}>Gateway fee</th>
            <th style={{ textAlign: 'center' }}>Technician amount</th>
            <th style={{ textAlign: 'center' }}>Paymob transaction ID</th>
            <th style={{ textAlign: 'center' }}>Status</th>
            <th style={{ textAlign: 'center' }}>Created date</th>
            <th style={{ textAlign: 'center' }}>Details</th>
          </tr>
        </thead>
        <tbody>
          {this.state.items.map((item, index) => {
            const fixerId = technicianId(item)
            return (
              <tr key={recordId(item) || index}>
                <td style={{ textAlign: 'center', ...rtlProps(technicianLabel(item)).style }}>
                  {fixerId ? (
                    <Button className="click" style={{ backgroundColor: 'transparent', borderColor: 'transparent', fontWeight: 'bold' }} onClick={() => this.props.history.push(`/cash-mahan/technicians/${fixerId}/wallet`)}>
                      {technicianLabel(item)}
                    </Button>
                  ) : technicianLabel(item)}
                </td>
                <td style={{ textAlign: 'center', ...rtlProps(customerLabel(item)).style }}>{customerLabel(item)}</td>
                <td style={{ textAlign: 'center' }}>{displayText(item.reference)}</td>
                <td style={{ textAlign: 'center' }}>{formatMoney(item.serviceAmount)}</td>
                <td style={{ textAlign: 'center' }}>{formatMoney(item.gatewayFee)}</td>
                <td style={{ textAlign: 'center' }}>{formatMoney(item.technicianAmount)}</td>
                <td style={{ textAlign: 'center' }}>{displayText(item.paymobTransactionId)}</td>
                <td style={{ textAlign: 'center' }}><CashMahanStatusBadge item={item} /></td>
                <td style={{ textAlign: 'center' }}>{formatDate(item.createdAt)}</td>
                <td style={{ textAlign: 'center' }}>
                  <Button className='actionsBtn' onClick={() => this.openDetails(item)}>View</Button>
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  render() {
    return (
      <div className="app align-items-center">
        <Container>
          {this.renderFilters()}
          <Card>
            <CardHeader className='shadow'>
              <i className="fa fa-align-justify"></i>
              <span style={{ marginLeft: 6 }}>Payment requests</span>
            </CardHeader>
            {this.state.error ? (
              <CashMahanError message={this.state.error} onRetry={() => this.load()} />
            ) : this.state.noResult ? (
              <CashMahanEmpty />
            ) : (
              <CardBody className='shadow'>
                {this.renderTable()}
                <Paginator prevPages={this.state.previousPages} nextPages={this.state.nextPages} notify={(page) => this.changePage(page)} />
              </CardBody>
            )}
          </Card>
          <FModal
            title="Payment request details"
            className="modal-lg"
            content={
              this.state.detailsModal ? (
                <PaymentRequestDetails
                  id={this.state.selectedId}
                  item={this.state.selectedItem}
                  history={this.props.history}
                />
              ) : null
            }
            state={this.state.detailsModal}
            onClose={() => this.setState({ detailsModal: false, selectedItem: null, selectedId: '' })}
            noSubmitBtn={true}
          />
          <LoadingSpinner loading={this.state.loading} />
        </Container>
      </div>
    )
  }
}
